module.exports = __webpack_public_path__ + "img/logo3.cd8224bf.png";